import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { doc, getDoc, serverTimestamp, updateDoc } from 'firebase/firestore';
import { db } from '../../services/firebase';
import { getCheckInOutState, CHECK_IN_ACTION, CHECK_OUT_ACTION } from '../../utils/checkInOut';

const CheckInOutPage = () => {
  const { companyId, reservationId, action, token } = useParams();
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('Processando sua confirmação...');

  useEffect(() => {
    const processAction = async () => {
      if (!companyId || !reservationId || !action) {
        setStatus('error');
        setMessage('Link de confirmação inválido.');
        return;
      }

      const normalizedAction = action === CHECK_OUT_ACTION ? CHECK_OUT_ACTION : CHECK_IN_ACTION;

      try {
        const reservationRef = doc(db, `companies/${companyId}/reservations/${reservationId}`);
        if (token) {
          const statusUpdates = {
            voucherToken: token,
            updatedAt: serverTimestamp(),
            checkInStatus: 'checked_in',
            status: normalizedAction === CHECK_OUT_ACTION ? 'completed' : 'confirmed'
          };

          if (normalizedAction === CHECK_OUT_ACTION) {
            statusUpdates.checkOutStatus = 'checked_out';
          }

          const reservationStatus = normalizedAction === CHECK_OUT_ACTION ? 'completed' : 'confirmed';

          await updateDoc(reservationRef, statusUpdates);

          try {
            const voucherUpdates = {
              checkInStatus: 'checked_in',
              status: reservationStatus,
              updatedAt: serverTimestamp()
            };

            if (normalizedAction === CHECK_OUT_ACTION) {
              voucherUpdates.checkOutStatus = 'checked_out';
            }

            await updateDoc(doc(db, 'publicVouchers', token), voucherUpdates);
          } catch (voucherError) {
            console.warn('Não foi possível atualizar o voucher público:', voucherError);
          }

          setStatus('success');
          setMessage(
            normalizedAction === CHECK_OUT_ACTION
              ? 'Check-out confirmado com sucesso!'
              : 'Check-in confirmado com sucesso!'
          );
          return;
        }

        const reservationSnap = await getDoc(reservationRef);

        if (!reservationSnap.exists()) {
          setStatus('error');
          setMessage('Reserva não encontrada.');
          return;
        }

        const reservation = reservationSnap.data();
        const state = getCheckInOutState(reservation, normalizedAction);

        if (!state.canUpdate) {
          setStatus('blocked');
          setMessage(state.reason || 'Não foi possível concluir esta ação.');
          return;
        }

        const updates = {
          updatedAt: serverTimestamp(),
          checkInStatus: normalizedAction === CHECK_IN_ACTION ? 'checked_in' : reservation.checkInStatus || 'pending',
          checkOutStatus: normalizedAction === CHECK_OUT_ACTION ? 'checked_out' : reservation.checkOutStatus || 'pending',
          status: normalizedAction === CHECK_OUT_ACTION ? 'completed' : (reservation.status === 'pending' ? 'confirmed' : reservation.status)
        };

        await updateDoc(reservationRef, updates);
        setStatus('success');
        setMessage(
          normalizedAction === CHECK_OUT_ACTION
            ? 'Check-out confirmado com sucesso!'
            : 'Check-in confirmado com sucesso!'
        );
      } catch (error) {
        console.error('Erro ao processar check-in/check-out:', error);
        setStatus('error');
        setMessage('Não foi possível concluir a confirmação. Tente novamente.');
      }
    };

    processAction();
  }, [companyId, reservationId, action, token]);

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f5f7fb', padding: 24 }}>
      <div style={{ maxWidth: 420, width: '100%', background: '#fff', borderRadius: 16, padding: 32, boxShadow: '0 10px 30px rgba(0,0,0,0.08)', textAlign: 'center' }}>
        <h2 style={{ marginBottom: 12, color: '#1f2937' }}>Confirmação de presença</h2>
        <p style={{ color: '#6b7280', marginBottom: 24 }}>{message}</p>
        <div style={{
          width: 90,
          height: 90,
          borderRadius: '50%',
          margin: '0 auto 16px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: 36,
          background: status === 'success' ? '#dcfce7' : status === 'blocked' || status === 'error' ? '#fee2e2' : '#e0f2fe',
          color: status === 'success' ? '#166534' : status === 'blocked' || status === 'error' ? '#b91c1c' : '#0369a1'
        }}>
          {status === 'success' ? '✓' : status === 'blocked' || status === 'error' ? '!' : '…'}
        </div>
        <p style={{ color: '#9ca3af', fontSize: 14 }}>Este processo pode ser usado com qualquer serviço e reserva cadastrada.</p>
      </div>
    </div>
  );
};

export default CheckInOutPage;
